import { render, staticRenderFns } from "./studentType.vue?vue&type=template&id=398428ff&scoped=true"
import script from "./studentType.vue?vue&type=script&lang=js"
export * from "./studentType.vue?vue&type=script&lang=js"
import style0 from "./studentType.vue?vue&type=style&index=0&id=398428ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398428ff",
  null
  
)

export default component.exports